<template>
  <fb-form-properties-manager id="patient-dose-spot-active-medications-v1-properties-yelb8b" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "PatientDoseSpotActiveMedicationsV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "checkbox",
          properties: {
            label: "Exclude from Load From Last Result"
          },
          property: "excludeFromLoadFromLastResult"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "dropdown",
          properties: {
            label: "Filter by Date",
            options: [
              {
                value: "all",
                text: "All"
              },
              {
                value: "currentday",
                text: "Current Day"
              },
              {
                value: "last7days",
                text: "Last 7 Days"
              },
              {
                value: "last30days",
                text: "Last 30 Days"
              },
              {
                value: "last3months",
                text: "Last 3 Months"
              }
            ]
          },
          property: "dateFilter",
          defaultValue: "all"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
